import { Layout } from "../shared/components/Layout";
import styles from "./ProjectsSearchPage.module.scss";
import { almiInSuit, backgroundDark, bookcase } from "../assets/images";
import { PreloadedImage } from "../shared/components/PreloadedImage";
import SearchForm from "../shared/components/SearchForm/SearchForm";
import { HeaderVariant } from "../shared/components/Header/types";
import { RecoveryProgressPopup } from "../shared/components/RecoveryProgressPopup";

export default function ProjectsSearchPage() {
  return (
    <Layout
      customMainClass={styles.searchMain}
      background={backgroundDark}
      customPlaceholder={styles.placeholder}
      showFooter
      darkMode
      headerVariant={HeaderVariant.White20WhiteWhiteLogo}
    >
      <div className={styles.container}>
        <SearchForm
          mode="project"
          headerText="Найди нужный проект"
          buttonText="Перенести проект"
          popupTitles={{
            loadingServers: "Загрузка проектов...",
            loadingSelect: "Загрузка проектов...",
          }}
        />
      </div>
      <PreloadedImage
        src={bookcase}
        alt="Книжный шкаф"
        className={styles.bookcase}
        width={643}
        height={745}
      />
      <PreloadedImage
        src={almiInSuit}
        alt="Алми в костюме"
        className={styles.character}
        width={380}
        height={587}
      />
      <RecoveryProgressPopup />
    </Layout>
  );
}